/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { getBlogPostById } from '@/core/components/blog/blogQueryOptions'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/blog/$blogId/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { blogId } }) => {
    return queryClient.ensureQueryData(getBlogPostById(auth.token!, blogId))
  },
  pendingComponent: LoadingList,
})
